import type { AdvertisersCategories, AdvertisersCategoriesServer } from '@metapic-apps/shared'

import { normalizeImage } from '@/lib/adapters/image.adapter'
import type {
  AdvertiserListItemServerType,
  AdvertiserListItemType,
} from '@/lib/types/advertiser.types'

export const normalizeAdvertiserItems = (
  items: AdvertiserListItemServerType[] = [],
): AdvertiserListItemType[] => {
  return items.map((item) => ({
    id: item.id,
    label: item.name,
    currency: item.currency,
    ...(item.logo && {
      logo: normalizeImage(item.logo),
    }),
  }))
}

export const normalizeAdvertisersCategories = (
  categories: AdvertisersCategoriesServer[],
): AdvertisersCategories[] =>
  categories.map((category) => ({
    id: category.id,
    name: category.name,
  }))
